import { Popover, Tooltip } from '@tecsinapse/cortex-react'
import React from 'react'
import { MdTurnLeft } from 'react-icons/md'
import { replyMessageVariants } from '@web/modules/core'

interface CopyToClipboardProps {
  enable: boolean
  onMouseOver: () => void
  onMouseLeave: () => void
  onClick: () => void
  size?: 'small' | 'medium' | 'large'
}

const { container, icon } = replyMessageVariants()

const ReplyMessage = ({
  enable,
  onMouseOver,
  onMouseLeave,
  onClick,
  size
}: CopyToClipboardProps) => {
  return (
    <div className={container()}>
      {enable && (
        <Popover.Root trigger='click'>
          <Popover.Trigger>
            <Tooltip text='Responder' placement='bottom'>
              <MdTurnLeft
                className={icon({ size })}
                onClick={onClick}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
              />
            </Tooltip>
          </Popover.Trigger>
        </Popover.Root>
      )}
    </div>
  )
}

export default ReplyMessage
